import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    stepsWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "auto",
      flexWrap: "nowrap",
      justifyContent: "space-between",
      margin: theme.spacing(7, 0, 12, 0),
    },
    stepWrapper: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
    },
    stepStatusIconWrapper: {
      alignItems: "center",
      borderRadius: "50%",
      color: theme.white00,
      display: "flex",
      fontSize: 12,
      height: "24px",
      justifyContent: "center",
      marginRight: theme.spacing(6),
      minWidth: "24px",
      width: "24px",

      "& svg": {
        color: "white",
        height: "16px",
        width: "16px",
      },
    },
    stepLabel: (props: { hasError?: boolean; errorStatus?: boolean }) => ({
      fontSize: 14,
      fontWeight: 500,
      color: props.hasError || props.errorStatus ? theme.red500 : "inherit",
    }),
    stepDescription: {
      fontSize: 10,
      color: theme.gray500,
      display: "block",
      letterSpacing: "0.4px",
      lineHeight: "16px",
      whiteSpace: "break-spaces",
    },
    active: (props: { hasError?: boolean }) => ({
      backgroundColor: "transparent",
      border: `1px solid ${props.hasError ? theme.red500 : theme.primary500}`,
    }),
    activeStepDot: (props: { hasError?: boolean }) => ({
      width: 10,
      height: 10,
      backgroundColor: props.hasError ? theme.red500 : theme.primary500,
      borderRadius: "50%",
    }),
    visited: {
      backgroundColor: theme.green500,
    },
    notVisited: {
      backgroundColor: theme.gray200,
      color: theme.gray800,
    },
    error: {
      backgroundColor: theme.red500,
      color: theme.white00,
      borderColor: theme.white00,
    },
    divider: {
      flexGrow: 1,
      margin: theme.spacing(0, 4),
      borderBottom: `1px solid ${theme.gray400}`,
    },
  }),
);
